import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BLOB_IMAGE_URL } from "../../../../config/appConfig";
import { BlobContainerConsts } from "../../../../models/constants/blobContainerConsts";
import { BonusConsts } from "../../models/constants/bonusConsts";
import { BonusTurnOverDetails } from "../../models/responses";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import localization from "../../../../config/localization";
import common from "../../../../utils/common";
import { formatUtcToLocalDateTime } from "../../../../utils/dateTimeHelper";

interface BonusTurnoverDetailsProps {
  verticalbonusname: string;
  data: BonusTurnOverDetails;
  getBetType: (value?: string | null) => string;
}
export default function BonusTurnoverDetails({
  verticalbonusname,
  data,
  getBetType,
}: BonusTurnoverDetailsProps) {
  const renderIconVerticalWise = (
    verticalbonusname: string,
    data: BonusTurnOverDetails,
  ): string => {
    if (data.gamename?.trim() === BonusConsts.AdjustedByAdmin) {
      return "/images/Adjusted-By-Admin.png";
    }

    switch (true) {
      case verticalbonusname.includes(BonusConsts.ExchangeVertical):
        return `/icons/Exchange/EventType/${data.gameicon}.svg`;

      case verticalbonusname.includes(BonusConsts.SportsVertical) ||
        verticalbonusname.includes(BonusConsts.SportsIndia):
        return `/icons/sports/sport-name/sport-${data.gameicon.toLowerCase().replace(" ", "").replace(":", "-")}.svg`;

      case verticalbonusname.includes(BonusConsts.CasinoVertical):
        return `${BLOB_IMAGE_URL}${BlobContainerConsts.GameSupplier}/${data.gameicon}`;
    }

    return "";
  };
  const displayName =
    (verticalbonusname.includes(BonusConsts.SportsVertical) ||
      verticalbonusname.includes(BonusConsts.SportsIndia)) &&
    getBetType(data.betType)
      ? getBetType(data.betType)
      : data.gamename;

  return (
    <>
      <div className="grid grid-cols-4">
        <div className="col-span-3 flex">
          <img
            src={renderIconVerticalWise(verticalbonusname, data)}
            alt="icon"
            className="size-5 inline mr-2"
            style={{
              filter:
                verticalbonusname.includes(BonusConsts.SportsVertical) ||
                verticalbonusname.includes(BonusConsts.SportsIndia)
                  ? "invert(1)"
                  : "none",
            }}
          />
          <span className="truncate text-sm">{displayName} </span>
        </div>
        <div className="text-right text-sm">
          {data.betamount.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
          <FontAwesomeIcon icon={faIndianRupeeSign} size="xs" />
        </div>
      </div>
      {data.betslipid && (
        <div>
          <span className="text-sm font-meduim text-[#A9A9A9]">
            {localization.betid}
          </span>
          <span className="float-right text-sm">
            {data.betslipid}
            <img
              src="/icons/ic-copy.svg"
              alt="Copy"
              className="size-4 inline ml-2 cursor-pointer"
              onClick={() =>
                common.copyIdToClipboard(
                  data.betslipid,
                  localization.transid_success_copied,
                )
              }
            />
          </span>
        </div>
      )}
      <div>
        <span className="text-sm font-meduim text-[#A9A9A9]">
          {localization.event_date}
        </span>
        <span className="float-right text-sm">
          {formatUtcToLocalDateTime(data.bettingdate)}
        </span>
      </div>
      {data.showminimumodds && (
        <div>
          <span className="text-sm font-meduim text-[#A9A9A9]">
            {localization.odds}
          </span>
          <span className="float-right text-sm">{data.minimumodds}</span>
        </div>
      )}
    </>
  );
}
